import { render, staticRenderFns } from "./intoGroupRelations.vue?vue&type=template&id=77ac39f2&scoped=true"
import script from "./intoGroupRelations.vue?vue&type=script&lang=js"
export * from "./intoGroupRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ac39f2",
  null
  
)

export default component.exports